import { makeAutoObservable, action, toJS, runInAction, makeObservable, observable } from "mobx";
import { Message } from "@arco-design/web-react";
import { setTokenToLocalStorage } from "@/utils/token";
import { makePersistable } from "mobx-persist-store";
import { getUserInfo } from "@/services/YsApi/account";
import { getIsTeam, getMyTeamsList, getUserAvatarUrl } from "@/services/user/user";
import { getAataIntegration } from "@/services/workbenck/workbenck";
import { envUrl } from "@/platformConfig";
const obj = {
  1: "Admin",
  2: "Service",
  3: "Market",
  4: "ServiceLead",
};
interface Ibanlance {
  id: number;
  balance: number;
  expired_at: number;
  created_at: number;
  updated_at: number;
}
interface IUserInfo {
  id: number;
  /**
   * agent_id 代理商ID
   */
  agent_id: number;
  /**
   * username 登录账号
   */
  username: string;
  /**
   * name 账号名称
   */
  name: string;
  /**
   * phone 手机号
   */
  phone: string;
  /**
   * role_id 角色ID  1:管理员 2:客服  3:销售  4:客服主管
   */
  role_id: number;
  role_name: string;
  /**
   * identity 身份 agent 代理商 staff 员工
   */
  identity: string;
  /**
   * status 1 启用 0 禁用
   */
  status: number;
  updated_at: number;
  /**
   * balance 云币
   */
  balance: number;
  /**
   * 数字人时长 数字人时长
   */
  digital_time: number;
  banlance: Ibanlance[];
  /**
   * 菜单权限
   */
  permissions: string[];
  type: number;
}

interface ICollection {
  job_num: number;
  script_num: number;
  session_num: number;
}

interface ICompose {
  month_composed: number;
  total_composed: number;
}

interface IPublish {
  month_published: number;
  published: number;
}

interface IDataIntegrationItem {
  benefits?: any[];
  collection?: ICollection;
  compose?: ICompose;
  publish?: IPublish;
}

class UserStore {
  userInfo: IUserInfo = {
    id: undefined,
    agent_id: undefined,
    username: "",
    name: "",
    phone: "",
    role_id: undefined,
    role_name: "",
    identity: "",
    status: undefined,
    updated_at: 0,
    digital_time: 0,
    balance: 0,
    banlance: [],
    permissions: [],
    type: undefined,
  };

  chatSession = "DouBao";
  isExpired_at_package = false;
  teamInfoLoaded = false;
  teamInfo = {
    team_user_role: {
      exists: "",
      nickname: "",
      status: 0,
      expired_at: 0,
      contact_status: 0,
      roles: [
        {
          code: "",
          description: "",
          id: "",
          name: "",
        },
      ],
      team: {
        id: "",
        name: "",
      },
    },
    teamList: {
      items: [],
      team_id: -1,
    },
    memberList: [],
  };
  dataIntegration: IDataIntegrationItem;
  logoWidth = 107;
  ChangeTeamMoadl = false;
  CreateTeamMoadl = false;
  ExclusiveModal = false;
  isHaveTeam = false;
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "UserStore",
      properties: ["userInfo", "teamInfo", "logoWidth", "dataIntegration", "isExpired_at_package", "chatSession"],
      storage: window.localStorage,
    });
  }

  getUserInfo = action(async (isHref?) => {
    const res = await getUserInfo();
    if (res?.code === 0) {
      await new Promise<void>((resolve) => {
        runInAction(() => {
          this.userInfo = {
            ...res.data.item,
            role_name: obj[res.data.item.role_id],
            banlance: res.data.banlance,
            permissions: JSON.parse(res.data?.item?.permissions || "[]"),
          };
          resolve();
        });
      });

      if (isHref) {
        window.location.href = envUrl["crm"];
      }
    }
  });
  getTeamInfo = action(async () => {
    const res = await getIsTeam();
    const resList = await getMyTeamsList();
  });
  setLogoWidth = action((width) => {
    this.logoWidth = width;
  });

  getDataIntegration = action(async () => {
    const res = await getAataIntegration();
    if (res?.data) {
      this.dataIntegration = res?.data?.workbench_data_integration || {};
    }
  });
  setIsExpired = action(async (status) => {
    this.isExpired_at_package = status;
  });
  setChangeTeamModal = action(async () => {
    this.ChangeTeamMoadl = !this.ChangeTeamMoadl;
  });
  setExclusiveModal = action(async (status) => {
    this.ExclusiveModal = status;
  });
  setCreateTeamModal = action(async () => {
    this.CreateTeamMoadl = !this.CreateTeamMoadl;
  });

  getTeamStatus = action(async () => {
    if (!this.teamInfoLoaded) {
      await this.getTeamInfo();
      this.teamInfoLoaded = true;
    }
    const res = await getIsTeam();
    const exists = res?.data?.team_user_role;
    const is = Boolean(exists?.team?.name?.length || 0);
    this.isHaveTeam = is;
    this.isExpired_at_package = Boolean(exists?.contact_status);
    this.ExclusiveModal = Boolean(!exists?.contact_status);
    if (!is) {
      if (this.teamInfo?.teamList?.items?.length) {
        this.setChangeTeamModal();
        return true;
      } else {
        this.setCreateTeamModal();
        return true;
      }
    } else {
      return false;
    }
  });
  setChatSession = action((session) => {
    this.chatSession = session;
  });
}
const User = new UserStore();
export default User;
